import ls from 'local-storage';
import { authDao, checkOpenConsultationsDao } from '@/service';

export default {
  state: {
    user: null,
    currentCompany: null,
    companies: [],
    currentNotFinishedConsultations: [],
    toastStatus: false,
    notFinishedConsultation: 0,
    notificationVisible: false,
    backgroundAdmin: false,
    backgroundStudent: false,
    visitor: false,
  },
  mutations: {
    UNSET_USER(state) {
      state.user = null;
    },
    SET_ADMIN_MODE(state, payload) {
      state.backgroundAdmin = payload;
    },
    SET_STUDENT_MODE(state, payload) {
      state.backgroundStudent = payload;
    },
    SET_USER(state, payload) {
      ls.set('u', payload);
      state.user = payload;
    },
    SET_COMPANIES(state, payload) {
      state.companies = payload;
    },
    SET_NOT_FINISHED_CONSULTATIONS(state, payload) {
      state.currentNotFinishedConsultations = payload;
    },
    SET_CURRENT_COMPANY(state, payload) {
      ls.set('c', payload);
      state.currentCompany = payload;
    },
    SET_APPEND_TOAST(state, payload) {
      state.toastStatus = payload;
    },
    SET_VISIBLE_TOAST(state, payload) {
      state.notificationVisible = payload;
    },
    SET_NFC(state, payload) {
      state.notFinishedConsultation = payload;
    },
    SET_VISITOR(state, payload) {
      state.visitor = payload;
    },
  },
  actions: {
    setVisitorMode({ commit }) {
      commit('SET_VISITOR', true);
    },
    getAllOpenConsultations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        checkOpenConsultationsDao
          .getAll(payload)
          .then((resp) => {
            commit('SET_NFC', 0);
            commit('SET_NFC', resp.data.not_finished_consultations.length);
            ls.set('nfc', resp.data.not_finished_consultations.length);
            resolve(resp.data.not_finished_consultations);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllOpenConsultationsAdm({ commit }, payload) {
      return new Promise((resolve, reject) => {
        checkOpenConsultationsDao
          .getAllAdm(payload)
          .then((resp) => {
            commit('SET_NFC', 0);
            commit('SET_NFC', resp.data.not_finished_consultations.length);
            ls.set('nfc', resp.data.not_finished_consultations.length);
            resolve(resp.data.not_finished_consultations);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async initAuth({ commit }) {
      return new Promise((resolve, reject) => {
        if (!ls.get('t')) {
          commit('UNSET_USER');
          resolve();
          return;
        } else if (ls.get('t')) {
          authDao
            .getUser()
            .then((resp) => {
              return new Promise((resolve) => {
                if (ls.get('u')) {
                  commit('SET_USER', ls.get('u'));
                } else {
                  commit('SET_USER', resp.data.user);
                }
                commit('SET_CURRENT_COMPANY', ls.get('c'));

                resolve();
              })
                .then(() => {
                  resolve(resp);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              commit('UNSET_USER');
              ls.clear();
              reject(err);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },

    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        authDao
          .login(payload)
          .then(async (resp) => {
            await ls.set('t', resp.data.token);
            authDao
              .getUser()
              .then((respUser) => {
                respUser.data.user = {
                  ...respUser.data.user,
                  role: respUser.data.role,
                };

                commit('SET_USER', respUser.data.user);

                if (respUser.data.user.companies.length === 1) {
                  commit(
                    'SET_CURRENT_COMPANY',
                    respUser.data.user.companies[0]
                  );
                  commit('SET_COMPANIES', respUser.data.user.companies);
                } 

                resolve(respUser);
              })
              .catch((err) => {
                commit('UNSET_USER');
                ls.clear();
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changePassword(_, payload) {
      return new Promise((resolve, reject) => {
        // console.log('aqui ', payload);
        authDao
          .changePassword(payload, ls.get('t'))
          .then((resp) => {
            resolve(resp);
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    updatePassword(_, payload) {
      return new Promise((resolve, reject) => {
        authDao
          .updatePassword(payload)
          .then((resp) => {
            resolve(resp);
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    updateAuthUser(_, payload) {
      return new Promise((resolve, reject) => {
        authDao
          .updateAuthUser(payload.user_id, payload.body)
          .then((resp) => {
            resolve(resp);
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    recoveryPassword(_, payload) {
      return new Promise((resolve, reject) => {
        authDao
          .recoveryPassword(payload)
          .then((resp) => {
            resolve(resp);
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    verifyHashRecoveryPassword(_, payload) {
      return new Promise((resolve, reject) => {
        authDao
          .verifyHashRecoveryPassword(payload)
          .then((resp) => {
            ls.set('t', resp.data.token.token);
            resolve(resp);
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    logout() {
      this.commit('UNSET_USER', null);
      ls.clear();
    },
  },
  getters: {
    user: (state) => state.user,
    companies: (state) => state.companies,
    currentNotFinishedConsultations: (state) =>
      state.currentNotFinishedConsultations,
    currentCompany: (state) => state.currentCompany,
    toastStatus: (state) => state.toastStatus,
    notificationVisible: (state) => state.notificationVisible,
    notFinishedConsultation: (state) => state.notFinishedConsultation,
    backgroundAdmin: (state) => state.backgroundAdmin,
    backgroundStudent: (state) => state.backgroundStudent,
    visitor: (state) => state.visitor,
  },
};
